import { type Dispatch, type SetStateAction, useCallback } from "react";

const COPY_TOOLTIP_DURATION_MS = 1000;

export function useCopyTooltip() {
	return useCallback((setStateFn: Dispatch<SetStateAction<boolean>>) => {
		setStateFn(true);
		setTimeout(() => setStateFn(false), COPY_TOOLTIP_DURATION_MS);
	}, []);
}
